import { redirectPath, welcomePath } from "./utils/paths";

// Auth
const tenantId = process.env.REACT_APP_TENANT_NAME ?? "";
const tenantURI = `${tenantId}.onmicrosoft.com`;
const resetPasswordPolicyName = "B2C_1_RESET_PASSWORD";
const signInSignUpPolicyName = process.env.REACT_APP_SIGNUP_POLICY;
export const authConfig = {
  FORGOT_PW_ERROR_CODE: "access_denied",
  FORGOT_PW_ERROR_INDICATOR: "AADB2C90118",
  tenantId,
  tenantURI,
  signInSignUpPolicyName,
  resetPasswordPolicyName,
  clientId: process.env.REACT_APP_APPLICATION_ID ?? "",
  authority:
    process.env.REACT_APP_AUTHORITY ??
    `https://${tenantId}.b2clogin.com/tfp/${tenantURI}/${signInSignUpPolicyName}`,
  resetAuthority:
    process.env.REACT_APP_RESET_AUTHORITY ??
    `https://${tenantId}.b2clogin.com/tfp/${tenantURI}/${resetPasswordPolicyName}`,
  useApiScope:
    process.env.REACT_APP_API_SCOPE ??
    `https://${tenantId}.onmicrosoft.com/customer-api/use_api`,
  redirectUri: (): string =>
    `${window.location.protocol}//${window.location.hostname}${
      window.location.port ? `:${window.location.port}` : ""
    }${redirectPath}`,
  logoutRedirectUri: (): string =>
    `${window.location.protocol}//${window.location.hostname}${
      window.location.port ? `:${window.location.port}` : ""
    }${welcomePath}`,
};
